import { environment as preprodEnv } from './environment.preprod';
import { AvailableEnvironments } from './models/available-environments';

export const availableEnvironments: AvailableEnvironments = [
  { name: preprodEnv.name, host: preprodEnv.host }
];
